import React, { FC } from 'react';
import { Box, Typography } from '@material-ui/core';
import summaryCashStyles from './summaryCashStyles';
import SecondaryPriceTotal from '../secondaryPriceTotal/SecondaryPriceTotal';
import SummaryCashTotalMulti from '../summaryCashTotal/SummaryCashTotalMulti';
import SummaryTypographyOr from '../../../SummaryTypographyOr/SummaryTypographyOr';
import DotsLoader from '../../../../../../../common/components/dotsLoader/DotsLoader';
import IndicativeNumber from '../../../../../../../common/components/indicativeNumber/IndicativeNumber';
import IPrice from '../../../../../../../gqlCommon/model/prices/IPrice';
import Translation from '../../../../../../../common/components/translation/Translation';

export interface ISummaryCashMultiProps {
  primaryTotal: IPrice;
  secondaryTotal: IPrice;
  isLoading: boolean;
  onIndicativeClick: () => void;
}

const SummaryCashMulti: FC<ISummaryCashMultiProps> = ({
  primaryTotal,
  isLoading,
  secondaryTotal,
  onIndicativeClick,
}) => {
  const styles = summaryCashStyles();

  if (isLoading) {
    return (
      <Box px={0} className={styles.pricesContainer}>
        <DotsLoader />
      </Box>
    );
  }

  return (
    <Box className={styles.pricesWrapper} data-test="container:cash_multicurrency">
      <Box px={0} className={styles.pricesContainer}>
        <SummaryCashTotalMulti primaryTotal={primaryTotal} />
        <SummaryTypographyOr />
        {secondaryTotal && (
          <Typography color="textSecondary" className={styles.price}>
            <SecondaryPriceTotal secondaryTotal={secondaryTotal} />
          </Typography>
        )}
      </Box>
      <Typography className={styles.priceLabel} data-test="customise:label:total_vehicle_price">
        <Translation id={`trans__configurator__customise_page_sticky_footer__driveaway_price_label`} />
        <IndicativeNumber
          dataTest="vehicle_total_price"
          displayNumber={<Translation id="trans__configurator__indicative_numbers__vehicleTotalPrice" />}
          onClick={onIndicativeClick}
        />
      </Typography>
    </Box>
  );
};

export default SummaryCashMulti;
